import React, {Component} from "react";
import simplyContext from "./simply";
import axios from "axios";
import {BASE_URL} from "../utils/config";
import {TIMEOUT} from "../utils/config";
import {toastAlerts} from "../utils/toastify";
import {translation} from "../translate/fa";
import {urlDynamic} from "../utils/urlDynamic";
import {data} from "../../app/components/components/data";

class GlobalState extends Component {
    state = {
         sIsLoggedIn: !!sessionStorage.getItem("authorization"),
        sNavigate: null,
        sPreloader: true,
        sOffConvas: false,
        sOffConvas2: false,
        sOffConvas3: false,
        sImageSliderIndex: 0,
        sHome: null,
        sPage: null,
        sNews: null,
        sKotobMarjaitElmi: null,
        sSearch: null,
        sGozaresheTasviriAll: null,
        sImageGallery: null,
        sInputSearch: '',
        menuStack: [
            {
                title: "منو",
                items: data().menu
            }
        ]
    }

    fSetLoggedIn = (value) => {
    this.setState({ sIsLoggedIn: value });
}

    fEnterMenu = (item) => {
        this.setState(prev => ({
            menuStack: [
                ...prev.menuStack,
                {
                    title: item.title,
                    items: item.child
                }
            ]
        }));
    }

    fBackMenu = () => {
        this.setState(prev => {
            if (prev.menuStack.length <= 1) return null;

            return {
                menuStack: prev.menuStack.slice(0, -1)
            };
        });
    }

    fResetMenu = () => {
        this.setState({
            menuStack: [
                {
                    title: "منو",
                    items: data().menu
                }
            ]
        });
    }

    fCurrentMenu = () => {
        const stack = this.state.menuStack;
        return stack[stack.length - 1];
    }


    fResetNavigate = () => {
        this.setState({sNavigate: null})
    }

    fNavigate = (path) => {
        this.setState({sNavigate: path})
    }

    fPreloader = (show) => {
        this.setState({sPreloader: show})
    }

    // todo:// grantha be koja mire  dar safhe asli


    fOffConvas = () => {
        this.setState(prev => ({
            sOffConvas: !prev.sOffConvas,
            menuStack: [
                {
                    title: "منو",
                    items: data().menu
                }
            ]
        }));
    }

    fOffConvas2 = (value) => {
        this.setState({sOffConvas2: !this.state.sOffConvas2})
        this.setState({sImageSliderIndex: value})
    }

    fOffConvas3 = () => {
        this.setState({sOffConvas3: !this.state.sOffConvas3})
        setTimeout(() => {
            const element = document.getElementById('x');
            if (element) {
                element.focus()
            }
        }, 100);
    }

    fSearchInput = (value) => {
        this.setState({sInputSearch: value.target.value})
    }

    fReset = () => {
        window.scrollTo(0, 0);
        this.setState({sOffConvas: false})
        this.setState({sOffConvas2: false})
        this.setState({sOffConvas3: false})
        this.setState({sInputSearch: ''})
        this.setState({sMenu: false})
        this.setState({sHome: null})
        this.setState({sPage: null})
        this.setState({sGozaresheTasviriAll: null})
        this.setState({sImageGallery: null})
        this.setState({sNews: null})
        this.setState({sKotobMarjaitElmi: null})
        this.setState({sSearch: null})
        this.setState({sImageSliderIndex: 0})
        this.setState({
            menuStack: [
                {
                    title: "منو",
                    items: data().menu
                }
            ]
        })
    }



    fNotPermission = (settings) => {
        if (settings.response === undefined) {
            toastAlerts({'data': {'code': 'error', "message": translation.msgError500}})
            this.fNavigate(urlDynamic.path.error500)
            console.log('error: Backend is down')
        } else {
            if (settings.response.status === 500) {
                this.fNavigate(urlDynamic.path.error500)
                console.log('error: Backend check log')
            } else {
                if (settings.response.status === 404) {
                    toastAlerts({'data': {'code': 'error', "message": translation.msgError500}})
                    this.fNavigate(urlDynamic.path.error500)
                    console.log('error: Backend url 404')
                }
            }
        }
    }

    fHome = () => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/home/', {
                timeout: TIMEOUT,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sHome: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }

    fDropDown = (name = null, value = null) => {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set(name, value);
        this.fNavigate(window.location.pathname + '?' + urlParams)
    }

    fNews = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/news/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sNews: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }


     fLogout = () => {
    axios.get(
        BASE_URL + '/api/v1/account/logout/', {
            timeout: TIMEOUT,
            headers: {
                "Content-Type": "application/json",
                "Authorization": sessionStorage.getItem("authorization") || ""
            }
        }
    ).then((response) => {
        toastAlerts(response);
    }).catch(error => {
        toastAlerts(error.response);
    }).finally(() => {
        sessionStorage.removeItem("authorization");
        this.fSetLoggedIn(false);
        this.fNavigate(urlDynamic.path.login);
        this.fPreloader(false);
    })
}


    fKotobMrjaiatElmi = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/kotob-marjaiat-elmi/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sKotobMarjaitElmi: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }

    fMahsoolatJadid = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/mahsoolat-jadid/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sKotobMarjaitElmi: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }

    fHekmatBonyan = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/hekmat-bonyan/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sKotobMarjaitElmi: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }

    fPezeshkKhanevade = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/pezeshk-khanevade/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sKotobMarjaitElmi: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }

    fNoavar = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/noavar/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sKotobMarjaitElmi: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }


    fHeyatElmi = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/heyat-elmi/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sKotobMarjaitElmi: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }


    fEghtesadModiriat = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/eghtesad-modiriat/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sKotobMarjaitElmi: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }


    fSalamat = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/salamat/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sKotobMarjaitElmi: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }


    fBimarestan = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/bimarestan/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sKotobMarjaitElmi: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }


    fCorona = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/corona/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sKotobMarjaitElmi: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }


    fSazVaKar = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/sazVaKar/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sKotobMarjaitElmi: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }


    fSarFasl = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/sarfasl/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sKotobMarjaitElmi: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }


    fMahsoolatSiasati = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/mahsoolat-siasati/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sKotobMarjaitElmi: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }


    fAmoozeshSalamat = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/amoozesh-salamat/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sKotobMarjaitElmi: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }


    fRotebaBandi = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/rotbebandi/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sKotobMarjaitElmi: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }


    fNokhbegan = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/nokhbegan/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sKotobMarjaitElmi: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }

    fSearch = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        this.setState({sInputSearch: params.search}, () => {
        });
        axios.get(
            BASE_URL + '/api/v1/page/search/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sSearch: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }

    fGozareshTasviriAll = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/images-gallery/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sGozaresheTasviriAll: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }

    fGozareshTasviri = (slug) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/images-gallery/images/?slug=' + slug, {
                timeout: TIMEOUT,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sImageGallery: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }

    fNewsMarjaiat = (params = {}) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/news-marjaiat/', {
                timeout: TIMEOUT,
                params: params,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sNews: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }

    fPage = (page) => {
        this.fPreloader(true)
        this.fReset()
        axios.get(
            BASE_URL + '/api/v1/page/page/?slug=' + page, {
                timeout: TIMEOUT,
                headers: {
                    "Content-Type": "application/json",
                }
            }
        ).then((response) => {
            this.setState({sPage: response.data.data})
            this.fPreloader(false)
        }).catch(error => {
            toastAlerts(error.response)
            this.fNotPermission(error)
            this.fPreloader(false)
        })
    }


    render() {
        return (
            <simplyContext.Provider value={{
                state: this.state,
                fResetNavigate: this.fResetNavigate,
                fNavigate: this.fNavigate,
                fPreloader: this.fPreloader,
                fOffConvas: this.fOffConvas,
                fReset: this.fReset,
                fOffConvas2: this.fOffConvas2,
                fHome: this.fHome,
                fNotPermission: this.fNotPermission,
                fPage: this.fPage,
                fNews: this.fNews,
                fDropDown: this.fDropDown,
                fNewsMarjaiat: this.fNewsMarjaiat,
                fGozareshTasviriAll: this.fGozareshTasviriAll,
                fGozareshTasviri: this.fGozareshTasviri,
                fSearch: this.fSearch,
                fOffConvas3: this.fOffConvas3,
                fSearchInput: this.fSearchInput,
                fKotobMrjaiatElmi: this.fKotobMrjaiatElmi,
                fMahsoolatJadid: this.fMahsoolatJadid,
                fHekmatBonyan: this.fHekmatBonyan,
                fNoavar: this.fNoavar,
                fPezeshkKhanevade: this.fPezeshkKhanevade,
                fHeyatElmi: this.fHeyatElmi,
                fEghtesadModiriat: this.fEghtesadModiriat,
                fSalamat: this.fSalamat,
                fBimarestan: this.fBimarestan,
                fRotebaBandi: this.fRotebaBandi,
                fNokhbegan: this.fNokhbegan,
                fCorona: this.fCorona,
                fEnterMenu: this.fEnterMenu,
                fBackMenu: this.fBackMenu,
                fResetMenu: this.fResetMenu,
                fCurrentMenu: this.fCurrentMenu,
                fAmoozeshSalamat: this.fAmoozeshSalamat,
                fMahsoolatSiasati: this.fMahsoolatSiasati,
                fSazVaKar: this.fSazVaKar,
                fSarFasl: this.fSarFasl,
                fLogout: this.fLogout,
                fSetLoggedIn: this.fSetLoggedIn,
            }}>
                {this.props.children}
            </simplyContext.Provider>
        )
    }
}

export default GlobalState
